import Header from "../../components/private/header";
import Main from "../../components/private/main";
import Footer from "../../components/private/footer";
import Login from "../../components/public/login";

export default () => {
  return (
    <>
      <Header user={null} />
      <Main content={<Login />} />
      <Footer />
    </>
  );
};
